var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlackGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5678_1130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9992 4.17357e-08C4.93666 4.17357e-08 0 4.93083 0 10.9953C0 17.06 4.93624 22 10.9992 22C17.0622 22 22 17.0602 22 10.9953C22 4.93056 17.0619 -0.000523818 10.9992 4.17357e-08ZM10.9992 1.82612C16.0712 1.82612 20.1671 5.92165 20.1671 10.9958C20.1671 16.0698 16.0712 20.167 10.9992 20.167C5.92698 20.167 1.83285 16.0698 1.83285 10.9958C1.83285 5.92192 5.92671 1.82665 10.9992 1.82612ZM10.9992 4.58005C10.7562 4.58005 10.523 4.67664 10.3512 4.84853C10.1793 5.02042 10.0828 5.2537 10.0828 5.4968C10.0828 5.73991 10.1793 5.97319 10.3512 6.14508C10.523 6.31697 10.7562 6.41356 10.9992 6.41356C11.2422 6.41356 11.4754 6.31697 11.6473 6.14508C11.8191 5.97319 11.9156 5.73991 11.9156 5.4968C11.9156 5.2537 11.8191 5.02042 11.6473 4.84853C11.4754 4.67664 11.2422 4.58005 10.9992 4.58005ZM10.9992 8.2489C10.7562 8.24788 10.5226 8.34365 10.3501 8.51492C10.1777 8.68599 10.0801 8.91886 10.0793 9.16199V16.4981C10.0801 16.7412 10.1777 16.9741 10.3501 17.1453C10.5226 17.3166 10.7562 17.4122 10.9992 17.4114C11.2414 17.4108 11.4734 17.3146 11.6448 17.1433C11.8162 16.9722 11.913 16.7404 11.9138 16.4981V9.16199C11.913 8.91991 11.8162 8.68785 11.6448 8.5168C11.4734 8.34573 11.2414 8.24931 10.9992 8.2489Z",
    fill: "#A2A2A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5678_1130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlackGrey);
export default __webpack_public_path__ + "static/media/info-black-grey.789029755d8384ecd764126d9e7f8aa3.svg";
export { ForwardRef as ReactComponent };